import { createStructuredSelector } from "reselect";
import {
    COM_INFRA_CODE,
    COM_INFRA_CODE_SUCCESS,
    COM_INFRA_CODE_ERROR,
    COM_INFRA_DESTINATION,
    COM_INFRA_DESTINATION_SUCCESS,
    COM_INFRA_DESTINATION_ERROR,
    COM_INFRA_AREA,
    COM_INFRA_AREA_SUCCESS,
    COM_INFRA_AREA_ERROR,
    COM_INFRA_PROJECT,
    COM_INFRA_PROJECT_SUCCESS,
    COM_INFRA_PROJECT_ERROR,
    COM_INFRA_TYPE,
    COM_INFRA_TYPE_SUCCESS,
    COM_INFRA_TYPE_ERROR,
    COM_INFRA_STATUS,
    COM_INFRA_STATUS_SUCCESS,
    COM_INFRA_STATUS_ERROR,
    COM_INFRA_SUPPLIER,
    COM_INFRA_SUPPLIER_SUCCESS,
    COM_INFRA_SUPPLIER_ERROR,
    COM_INFRA_USER_ASSIGN,
    COM_INFRA_USER_ASSIGN_SUCCESS,
    COM_INFRA_USER_ASSIGN_ERROR,
    COM_INFRA_LIST,
    COM_INFRA_LIST_SUCCESS,
    COM_INFRA_LIST_ERROR,
    COM_INFRA_SEARCH_CHANGE,
    COM_INFRA_PAGE_SET,
    COM_INFRA_EDIT_MODAL_SET,
    COM_INFRA_EDIT_SET_DATA,
    COM_INFRA_EDIT_CHANGE_SET,
    COM_INFRA_EDIT,
    COM_INFRA_EDIT_SUCCESS,
    COM_INFRA_EDIT_ERROR,
    COM_INFRA_ANSWER_MODAL_SET,
    COM_INFRA_ANSWER_SET_DATA,
    COM_INFRA_ANSWER_CHANGE_SET,
    COM_INFRA_ANSWER,
    COM_INFRA_ANSWER_SUCCESS,
    COM_INFRA_ANSWER_ERROR,
    COM_INFRA_SEE_MODAL_SET,
    COM_INFRA_SEE_SET_DATA,
    COM_INFRA_UPLOAD_SET,
    COM_INFRA_UPLOAD_SET_SUCCESS,
    COM_INFRA_UPLOAD_SET_ERROR,
    COM_INFRA_UPLOAD_RESET,
} from "../../actions";

export const NAME = 'communicationInfra';

export const ComInfraCode = (data) => ({ type: COM_INFRA_CODE, payload: data });
export const ComInfraCodeSuccess = (data) => ({ type: COM_INFRA_CODE_SUCCESS, payload: data });
export const ComInfraCodeError = (error) => ({ type: COM_INFRA_CODE_ERROR, payload: error });

export const ComInfraDestination = (data) => ({ type: COM_INFRA_DESTINATION, payload: data });
export const ComInfraDestinationSuccess = (data) => ({ type: COM_INFRA_DESTINATION_SUCCESS, payload: data });
export const ComInfraDestinationError = (error) => ({ type: COM_INFRA_DESTINATION_ERROR, payload: error });

export const ComInfraArea = (data) => ({ type: COM_INFRA_AREA, payload: data });
export const ComInfraAreaSuccess = (data) => ({ type: COM_INFRA_AREA_SUCCESS, payload: data });
export const ComInfraAreaError = (error) => ({ type: COM_INFRA_AREA_ERROR, payload: error });

export const ComInfraProject = (data) => ({ type: COM_INFRA_PROJECT, payload: data });
export const ComInfraProjectSuccess = (data) => ({ type: COM_INFRA_PROJECT_SUCCESS, payload: data });
export const ComInfraProjectError = (error) => ({ type: COM_INFRA_PROJECT_ERROR, payload: error });

export const ComInfraType = (data) => ({ type: COM_INFRA_TYPE, payload: data });
export const ComInfraTypeSuccess = (data) => ({ type: COM_INFRA_TYPE_SUCCESS, payload: data });
export const ComInfraTypeError = (error) => ({ type: COM_INFRA_TYPE_ERROR, payload: error });

export const ComInfraStatus = (data) => ({ type: COM_INFRA_STATUS, payload: data });
export const ComInfraStatusSuccess = (data) => ({ type: COM_INFRA_STATUS_SUCCESS, payload: data });
export const ComInfraStatusError = (error) => ({ type: COM_INFRA_STATUS_ERROR, payload: error });

export const ComInfraSupplier = (data) => ({ type: COM_INFRA_SUPPLIER, payload: data });
export const ComInfraSupplierSuccess = (data) => ({ type: COM_INFRA_SUPPLIER_SUCCESS, payload: data });
export const ComInfraSupplierError = (error) => ({ type: COM_INFRA_SUPPLIER_ERROR, payload: error });

export const ComInfraUserAssign = (data) => ({ type: COM_INFRA_USER_ASSIGN, payload: data });
export const ComInfraUserAssignSuccess = (data) => ({ type: COM_INFRA_USER_ASSIGN_SUCCESS, payload: data });
export const ComInfraUserAssignError = (error) => ({ type: COM_INFRA_USER_ASSIGN_ERROR, payload: error });

export const ComInfraList = (page, num_page, orderBy, filters) => ({
    type: COM_INFRA_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters }
});
export const ComInfraListSuccess = (data) => ({ type: COM_INFRA_LIST_SUCCESS, payload: data });
export const ComInfraListError = (error) => ({ type: COM_INFRA_LIST_ERROR, payload: error });

export const ComInfraPageSet = (data) => ({ type: COM_INFRA_PAGE_SET, payload: data });
export const ComInfraSearchChange = (data) => ({ type: COM_INFRA_SEARCH_CHANGE, payload: data });

export const ComInfraEditModalSet = (data) => ({ type: COM_INFRA_EDIT_MODAL_SET, payload: data });
export const ComInfraEditSetData = (data) => ({ type: COM_INFRA_EDIT_SET_DATA, payload: data });
export const ComInfraEditChangeSet = (data) => ({ type: COM_INFRA_EDIT_CHANGE_SET, payload: data });
export const ComInfraEdit = (page, num_page, orderBy, filters, data) => ({
    type: COM_INFRA_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});
export const ComInfraEditSuccess = (message) => ({ type: COM_INFRA_EDIT_SUCCESS, payload: message });
export const ComInfraEditError = (error) => ({ type: COM_INFRA_EDIT_ERROR, payload: error });



export const ComInfraAnswerModalSet = (data) => ({ type: COM_INFRA_ANSWER_MODAL_SET, payload: data });
export const ComInfraAnswerSetData = (data) => ({ type: COM_INFRA_ANSWER_SET_DATA, payload: data });
export const ComInfraAnswerChangeSet = (data) => ({ type: COM_INFRA_ANSWER_CHANGE_SET, payload: data });
export const ComInfraAnswer = (page, num_page, orderBy, filters, data) => ({
    type: COM_INFRA_ANSWER,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});
export const ComInfraAnswerSuccess = (message) => ({ type: COM_INFRA_ANSWER_SUCCESS, payload: message });
export const ComInfraAnswerError = (error) => ({ type: COM_INFRA_ANSWER_ERROR, payload: error });



export const ComInfraSeeModalSet = (data) => ({ type: COM_INFRA_SEE_MODAL_SET, payload: data });
export const ComInfraSeeSetData = (data) => ({ type: COM_INFRA_SEE_SET_DATA, payload: data });

export const ComInfraUploadSet = (file, uploadId) => ({ type: COM_INFRA_UPLOAD_SET, payload: { file, uploadId } });
export const ComInfraUploadSetSuccess = (items) => ({ type: COM_INFRA_UPLOAD_SET_SUCCESS, payload: items });
export const ComInfraUploadSetError = (error) => ({ type: COM_INFRA_UPLOAD_SET_ERROR, payload: error });
export const ComInfraUploadRemove = (uploadId) => ({ type: COM_INFRA_UPLOAD_REMOVE, payload: uploadId });
export const ComInfraUploadReset = () => ({ type: COM_INFRA_UPLOAD_RESET });

const communicationInfra = (state) => state[NAME];

export const CommunicationInfraSelector = createStructuredSelector({
    communicationInfra
});
